import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../hooks/useStore';
import logoImage from '../../assets/logo1.png';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

export const Logo = observer(({ size = 'medium', showText = true }: LogoProps) => {
  const { themeStore } = useStore();
  const { themeClasses } = themeStore;

  const sizeClasses = {
    small: {
      container: 'w-12 h-12',
      image: 'w-10 h-10',
      text: 'text-lg'
    },
    medium: {
      container: 'w-20 h-20',
      image: 'w-16 h-16',
      text: 'text-2xl'
    },
    large: {
      container: 'w-24 h-24',
      image: 'w-20 h-20',
      text: 'text-3xl'
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className={`${sizeClasses[size].container} rounded-2xl flex items-center justify-center overflow-hidden`}>
        <img
          src={logoImage}
          alt="Faster CMS Logo"
          className={`${sizeClasses[size].image} object-contain`}
        />
      </div>
      {showText && (
        <h1 className={`${sizeClasses[size].text} font-bold ${themeClasses.text.primary} mt-2`}>
          Faster CMS
        </h1>
      )}
    </div>
  );
});
